import React from 'react';
import { useParams } from 'react-router-dom';
import { EntryType } from 'components/registry/types/api';
import { ViewRecordAndRequest } from '../../components/ViewRecordAndRequest';
import { breadcrumbs } from './consts';

const FeedAdditiveViewRequest = () => {
  const { id } = useParams();
  return (
    <ViewRecordAndRequest
      title="Просмотр заявки"
      breadcrumbs={breadcrumbs}
      cardLink={`/registry/feed/requests/${id}`}
      registryLink="/registry/feed/requests"
      entryType={EntryType.requests}
    />
  );
};

export default FeedAdditiveViewRequest;
